var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 0.333344C4.0835 0.333344 1.59266 2.14751 0.583496 4.70834C1.59266 7.26918 4.0835 9.08334 7.00016 9.08334C9.91683 9.08334 12.4077 7.26918 13.4168 4.70834C12.4077 2.14751 9.91683 0.333344 7.00016 0.333344ZM7.00016 7.62501C5.39016 7.62501 4.0835 6.31834 4.0835 4.70834C4.0835 3.09834 5.39016 1.79168 7.00016 1.79168C8.61016 1.79168 9.91683 3.09834 9.91683 4.70834C9.91683 6.31834 8.61016 7.62501 7.00016 7.62501ZM7.00016 2.95834C6.03183 2.95834 5.25016 3.74001 5.25016 4.70834C5.25016 5.67668 6.03183 6.45834 7.00016 6.45834C7.9685 6.45834 8.75016 5.67668 8.75016 4.70834C8.75016 3.74001 7.9685 2.95834 7.00016 2.95834Z",
    fill: "#041C2C",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7c3618404fc9e0054ed6d99c33aa6533.svg";
export { ForwardRef as ReactComponent };